import {
  ThePackRoot,
  ImageGrid,
  ImageWrapper,
  Header,
  BorderWrapper,
  SliderContainer,
} from './ThePack.styles'
import { useTranslation } from 'hooks/useTranslation'
import Image, { StaticImageData } from 'next/image'
import thumb1 from '../../../../../public/assets/reviews/thePack1.png'
import thumb2 from '../../../../../public/assets/reviews/thePack2.png'
import thumb3 from '../../../../../public/assets/reviews/thePack3.png'
import thumb4 from '../../../../../public/assets/reviews/thePack4.png'
import thumb5 from '../../../../../public/assets/reviews/thePack5.png'
import { Text } from 'components/Text'
import { BorderWave } from 'components/BorderWave'
import { SectionTitle } from 'features/Reviews/Reviews.styles'
import Trans from 'next-translate/Trans'
import Slider from 'react-slick'
import { sliderSettings } from 'fixtures/slider'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
export const ThePack = () => {
  const { t } = useTranslation()

  const instaSliderSettings = { ...sliderSettings, dots: false, autoplay: true }

  type postType = {
    imageSrc: StaticImageData
    imageAlt: string
    url: string
  }

  const instaPosts: postType[] = [
    {
      imageSrc: thumb1,
      imageAlt: '',
      url: 'https://www.instagram.com/reel/C3_K7vXr86J/',
    },
    {
      imageSrc: thumb2,
      imageAlt: t('reviews:thePack.imageAltRecipes'),
      url: 'https://www.instagram.com/p/C6Rve1IvhWb/',
    },
    {
      imageSrc: thumb3,
      imageAlt: '',
      url: 'https://www.instagram.com/p/C6i2ArYruGt/',
    },
    {
      imageSrc: thumb4,
      imageAlt: t('reviews:thePack.imageAltVenison'),
      url: 'https://www.instagram.com/reel/C8CLd-EO4PY/',
    },
    {
      imageSrc: thumb5,
      imageAlt: '',
      url: 'https://www.instagram.com/p/C43N0JVLtKX/',
    },
  ]

  return (
    <>
      <BorderWrapper>
        <BorderWave
          bottom
          background="primary-450"
          svgHeight="64px"
          svgWidth="calc(144% + 1.3px)"
          path="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z"
        />
      </BorderWrapper>
      <ThePackRoot>
        <Header>
          <SectionTitle color="secondary">{t('reviews:thePack.title')}</SectionTitle>
          <Text
            className="desktop-only"
            align="center"
            color="accent-white"
            size={{ '@initial': 'body', '@bp2': 'bodyLarge' }}
          >
            {t('reviews:thePack.subtitle')}
          </Text>
          <Text
            className="mobile-only"
            align="center"
            color="accent-white"
            size={{ '@initial': 'body', '@bp2': 'bodyLarge' }}
          >
            <Trans components={{ br: <br /> }} i18nKey="reviews:thePack.subtitle-mobile" />
          </Text>
        </Header>
        <ImageGrid className="desktop-only">
          {instaPosts.map((post, index) => (
            <ImageWrapper key={index}>
              <a
                style={{ display: 'block' }}
                href={post.url}
                key={index}
                target="_blank"
                rel="noreferrer"
              >
                <Image layout="fill" objectFit="cover" src={post.imageSrc} alt={post.imageAlt} />{' '}
              </a>
            </ImageWrapper>
          ))}
        </ImageGrid>
        <SliderContainer className="mobile-only">
          <Slider {...instaSliderSettings}>
            {instaPosts.map((post, index) => (
              <ImageWrapper key={index}>
                <a href={post.url} key={index} target="_blank" rel="noreferrer">
                  <Image layout="fill" objectFit="cover" src={post.imageSrc} alt={post.imageAlt} />{' '}
                </a>
              </ImageWrapper>
            ))}
          </Slider>
        </SliderContainer>
      </ThePackRoot>
    </>
  )
}
